module.exports = __webpack_public_path__ + "img/icon-bell-selected.5636dc67.svg";